import TabOptions from '../options';

export class Model {}
export class Tab {
  id = 'Nine';
  title = 'IX';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...model,
    };
  };
}
export default new Tab();
